import React from 'react'
import { Col,Button } from 'reactstrap';
import { Dialog } from 'primereact/dialog';


export const ModalRecollected = (props) => {

    const {modalCollected,handleToggleCollected,dataCollected,saveDetailSamplingsNotCollected} = props;

    return (
        <Dialog 
            header="Cancelar muestra"
            visible={modalCollected}
            onHide={handleToggleCollected}
            headerStyle={{
                    backgroundColor: '#c0130aff',
                    color: 'white',
                    fontWeight: 'bold',
                }}
            pt={{
                    header: { style: { backgroundColor: '#c0130aff', color: 'white' } },
                    headerIcon: { style: { color: 'white' } },
                }}
            className="pt-0 custom-dialog-img-sample"
            footer={
                <div>
                     <Button color="secondary text-center" type="button"  onClick={() => saveDetailSamplingsNotCollected(dataCollected.folio,dataCollected.id_quoter_type_sample,dataCollected.id_mic_type_sample)} >{"Aceptar"}</Button>
                </div>
            }
        >
                 <Col sm="12" style={{textAlign:"center"}} className='pt-3' >
                 <img alt="flask"  src={require("../../../assets/images/price/warningRecollected.svg")} style={{ width: "90px", height: "90px" }} />
                 </Col>
                 <Col sm="12" className='pt-1' style={{textAlign:"-webkit-center"}}>
                 <div style={{
					    backgroundColor: "#f97316",
						width: "130px",
						height: "25px",
						borderRadius: "8px",
						color: "#fff",
						fontSize:"10px",
						paddingTop:"4px"
					}}>
                    <i className="fa fa-angle-right f-12"></i>&nbsp;
                    <label className='f-w-00' style={{fontSize:"12px"}} >{dataCollected?.folio ?? "------"}</label>
				</div> 
                </Col>
                <Col sm="12" className='pt-2 p-l-0 p-r-0'>
                <b className='txt-danger f-w-700 f-14'>Esta muestra no sera reportada esta seguro de realizarlo</b>
                </Col>
                <Col sm="12" style={{textAlign : "right"}} className='p-l-0 p-r-0' > 
            </Col>       
        </Dialog>
        
       
    )
}